import {Component, ViewChild} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {WalletService} from "./wallet.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {AuthService} from "../../shared/services/auth.service";
import {ToastrService} from "ngx-toastr";
import {Network} from "./wallet.model";

@Component({
  selector: 'app-wallet',
  templateUrl: './wallet.component.html',
  styleUrls: ['./wallet.component.scss']
})
export class WalletComponent {
  public wallets: any;
  public isInsert: boolean;
  public isSubmitted: boolean;
  public isLoaded: boolean;
  public symbols: any;
  public redes: Network[];
  public selectedWallet: any;

  wallet = new FormGroup({
    descricao: new FormControl<string>('',Validators.required),
    hash: new FormControl<string>('',Validators.required),
    rede: new FormControl<string>('',Validators.required),
    symbol: new FormControl<string>('',Validators.required),
    terms : new FormControl<boolean>(false)
  });

  constructor(private walletService: WalletService,
              private modalService: NgbModal,
              private authService : AuthService,
              private toastr: ToastrService)
  {
    this.isInsert = false;
    this.isSubmitted = false;
    this.isLoaded = false;
    this.selectedWallet = null;
    this.redes = [];
    this.loadWallets();
  }

  loadSymbols(){
    this.isLoaded = false;
    this.walletService.getSymbols().subscribe(
      value => {
        this.symbols = value;
        this.isLoaded = true;
      }
    );
  }

  loadNetworks(){
    this.isLoaded = false;
    this.walletService.getNetworks().subscribe(
      value => {
        this.redes = value;
        this.isLoaded = true;
      }
    );
  }

  loadWallets(){
    this.isLoaded = false;
    this.walletService.getWallets().subscribe(
      value => {
        this.wallets = value;
        this.isLoaded = true
      }
    )
  }

  openInsert() {
    this.isInsert = true;
    this.loadSymbols();
    this.loadNetworks();
  }

  return() {
    this.isInsert = false;
    this.clearForm();
  }

  clearForm(){
    this.wallet.controls.descricao.setValue('');
    this.wallet.controls.hash.setValue('');
    this.wallet.controls.rede.setValue('');
    this.wallet.controls.symbol.setValue('');
    this.isSubmitted = false;

  }

  add() {
    this.isSubmitted = true;

    if(!this.wallet.controls.terms.value!){
      this.toastr.error("Aceite o termo para prosseguir com o cadastro!",'Erro',{
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
      return;
    }
    if(this.wallet.valid){
      let wallet = {
        symbolId : this.wallet.controls.symbol.value,
        description : this.wallet.controls.descricao.value,
        network : this.wallet.controls.rede.value,
        hash: this.wallet.controls.hash.value,
        accountId: this.authService.getAccountId()
      }
      this.walletService.add(wallet).subscribe(
        value => {
          this.return();
          this.loadWallets();
        }
      );
    }
  }

  enableDisableWallet(){
    this.walletService.enableDisableWallet({
      accountId : this.selectedWallet.accountId,
      id : this.selectedWallet.id,
      isEnable : !this.selectedWallet.enable
    }).subscribe(
      value => {
        this.loadWallets();
        this.modalService.dismissAll();
      }
    )
  }

  showConfirmEnableDisable(modal: any, wallet: any){
    this.selectedWallet = wallet;
    this.modalService.open(modal, { size: 'sm' });
  }
}
